import merge from 'lodash/merge';
// date fns
import { enUS as enUSAdapter, ptBR as ptBRAdapter } from 'date-fns/locale';

// core (MUI)
import { enUS as enUSCore, ptBR as ptBRCore } from '@mui/material/locale';
// data grid (MUI)
import { enUS as enUSDataGrid, ptBR as ptBRDataGrid } from '@mui/x-data-grid';
// date pickers (MUI)
import { enUS as enUSDate, ptBR as ptBRDate } from '@mui/x-date-pickers/locales';

import { StoreCurrencyType } from 'src/graphql/generated';

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    currencyName: 'Real',
    currencyNamePlural: 'Reais',
    currencyShort: 'R$',
    currencyType: StoreCurrencyType.Real,
    label: 'Portuguese',
    value: 'pt-BR',
    systemValue: merge(ptBRDate, ptBRDataGrid, ptBRCore),
    adapterLocale: ptBRAdapter,
    icon: 'flagpack:br',
    numberFormat: {
      code: 'pt-BR',
      currency: 'BRL',
    },
  },
  {
    currencyName: 'Dollar',
    currencyNamePlural: 'Dollars',
    currencyShort: '$',
    currencyType: StoreCurrencyType.Dolar,
    label: 'English',
    value: 'en',
    systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
    adapterLocale: enUSAdapter,
    icon: 'flagpack:gb-nir',
    numberFormat: {
      code: 'en-US',
      currency: 'USD',
    },
  },
];

export const defaultLang = allLangs[0]; // Portuguese

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
